{
	"noData": {
		"title": "Nous n'avons pas trouvé ce que vous cherchez",
		"description": "Essayez de sélectionner un nouvel emplacement ou une période, ou réessayez plus tard."
	},
	"noFilters": {
		"title": "Il n'y a encore rien ici",
		"description": "Sélectionnez l'emplacement de recherche ou vérifiez à nouveau plus tard."
	},
	"noContent": {
		"title": "Il n'y a encore rien ici",
		"description": "Sélectionnez une période pour commencer à explorer les données."
	}
}
